
import { MongoView } from "@/models/mongo-view";
import { IAvailableMongoViewColumn, MongoViewColumn } from "@/utils/mongo-view/mongo-view-column";
import AppColumnEdit from "./ColumnEdit.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			toEditColumn: null as null | MongoViewColumn,
		};
	},
	props: {
		view: {
			type: Object as ()=>MongoView,
			required: true
		},
		availableColumns: {
			type: Array as ()=>IAvailableMongoViewColumn[],
			required: true
		}
	},
	computed: {
		toEditIsNew():boolean{
			if (!this.toEditColumn) return true;
			return this.view.Columns.indexOf(this.toEditColumn) == -1;
		},
		sortableAttributes():any{
			return {
				tag: "w-list",
				disableX: true,
				keepInY: true,
				targetClass: "handle",
				items: this.view.Columns
			};
		}
	},
	methods: {
		editCol(col:MongoViewColumn){
			this.toEditColumn = col;
		},
		deleteCol(col:MongoViewColumn){
			let i = this.view.Columns.indexOf(col);
			if (i == -1) return;
			this.view.Columns.splice(i, 1);
		},
		createCol(){
			this.toEditColumn = MongoViewColumn.fromAvailableColumn(this.availableColumns[0]);
		},
		onEditInput(col:MongoViewColumn){
			if (!this.toEditColumn) return;
			let i = this.view.Columns.indexOf(this.toEditColumn);
			if (i == -1){
				this.view.Columns.push(col);
			}else{
				this.$set(this.view.Columns, i, col);
			}
		}
	},
	components: {
		AppColumnEdit
	},
	i18nEx: {
		componentPrefix: "components.mongo-view-editor"
	}
});
